import type { TRuleWithTheme } from 'styles/theme';

export const formItem: TRuleWithTheme = () => ({});

export const select: TRuleWithTheme = () => ({});
